import React from "react";
// import BgSuccess from "../../images/bg-success.svg";
import { Button, Descriptions } from "antd";
import _ from "lodash";
import { usePaymentResultLogic } from "../../hooks/usePaymentResultLogic";

const PaymentResult = ({ setLoading, loading }) => {
  const { statusPayment, bookingHotel } = usePaymentResultLogic({ setLoading });

  const items = [
    {
      key: "orderCode",
      label: "Mã đơn hàng",
      children: <>{bookingHotel?.orderCode}</>,
    },
    {
      key: "customer",
      label: "Thông tin liên hệ",
      children: (
        <div>
          <span>Tên khách hàng: {bookingHotel?.customerName}</span>
          <br />
          <span>Email: {bookingHotel?.customerEmail}</span>
          <br />
          <span>Số điện thoại: {bookingHotel?.customerPhone}</span>
        </div>
      ),
    },
    {
      key: "hotel",
      label: "Thông tin khách sạn",
      children: (
        <div>
          <span>Tên khách sạn: {bookingHotel?.hotelName}</span>
          <br />
          <span>Địa chỉ: {bookingHotel?.hotelAddress}</span>
        </div>
      ),
    },
    {
      key: "timeCheck",
      label: "Thời gian Checkin - Checkout",
      children: (
        <div>
          <span>Checkin: {bookingHotel?.hotelCheckin}</span>
          <br />
          <span>Checkout: {bookingHotel?.hotelCheckout}</span>
        </div>
      ),
    },
    {
      key: "room",
      label: "Thông tin phòng",
      children: (
        <div>
          <span>Loại phòng: {bookingHotel?.roomTypeName}</span>
          <br />
          <span>Số lượng phòng: {bookingHotel?.numberOfUnits}</span>
        </div>
      ),
    },
    {
      key: "room",
      label: "Thông tin khách đặt phòng",
      children: (
        <div>
          {bookingHotel?.hotelTransactionPeople?.map((item) => (
            <>
              <br />
              <span>Họ và tên: {item?.fullName}</span>
              <br />
              <span>Phòng số : {item?.roomIndex}</span>
            </>
          ))}
        </div>
      ),
    },
    {
      key: "VAT",
      label: "VAT",
      children: (
        <>
          {bookingHotel?.vatMst ? (
            <>
              Mã số thuế: {bookingHotel?.vatMst}
              <br />
              Họ tên: {bookingHotel?.vatFullName}
              <br />
              Email: {bookingHotel?.vatEmail}
            </>
          ) : (
            "Không"
          )}
        </>
      ),
    },
    {
      key: "amount",
      label: "Tổng tiền",
      children: (
        <div className="text-[16px] text-red-700 font-semibold">
          {bookingHotel?.amount?.toLocaleString("vi-VN")} đ
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col items-center pt-[24px] absolute w-full">
      <div className="w-[90%]">
        <div className="w-full">
          {/* <img src={BgSuccess} alt="" className="w-full" /> */}
          <div className="flex flex-col justify-center gap-4">
            {!loading && (
              <>
                {statusPayment ? (
                  <div className="flex flex-col p-4 bg-white rounded-lg">
                    <div className="text-[24px] text-[#00AB56] font-bold text-center mb-4 uppercase">
                      Thanh toán thành công
                    </div>
                    {!_.isNil(bookingHotel) && (
                      <Descriptions
                        title="Thông tin đặt phòng"
                        bordered
                        items={items}
                      />
                    )}
                  </div>
                ) : (
                  <div className="flex flex-col p-4 bg-white rounded-lg">
                    <div className="text-[24px] text-[#D72F20] font-bold text-center uppercase">
                      Thanh toán thất bại
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
        {/* <div className="w-full px-4 mt-4">
          <div className="flex justify-between">
            <Button
              onClick={() => {
                window.location.href = "/booking-taxi";
              }}
              className="w-[45%] h-[45px] rounded-[10px] text-center mx-auto bg-white text-primary border-primary text-[15px]"
            >
              <span className="font-semibold">Trang chủ</span>
            </Button>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default PaymentResult;
